const THEME_STORAGE_KEY = 'theme';

function readStoredTheme() {
  if (typeof window === 'undefined') return 'light';
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  return stored === 'dark' ? 'dark' : 'light';
}

let themeMode = readStoredTheme();
const listeners = new Set();

function applyThemeToDocument(mode) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', mode);
}

if (typeof document !== 'undefined') {
  applyThemeToDocument(themeMode);
}

export function getProductsTheme() {
  return themeMode;
}

export function subscribeProductsTheme(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function setProductsTheme(isDark) {
  const next = isDark ? 'dark' : 'light';
  if (next === themeMode) return;
  themeMode = next;
  applyThemeToDocument(next);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  listeners.forEach((listener) => listener());
}
